import "@Styles/mandate.css";
import React from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import OtpInput from "react-otp-input";
// import Form from "semantic-ui-react/dist/commonjs/collections/Form"
import mobile from "@Images/NewUI/mobile.png";
import { connect } from "react-redux";
import { Form } from "semantic-ui-react";
import { resendOtp, verifyOtp } from "../../../../Redux/Authenticate/action";
import ToastMsg from "../../../../helper/ToastMsg";
import { withRouter } from "../../../../hooks/withRouter";
import Heading from "../../Common/MainHeading";
import { HEADING_FORG0TMPIN } from "../../Common/constant";
const optInput = {
  display: "inline",
  float: "left",
  width: "3.3rem",
  padding: "24px 20px",
  margin: "0 5px",
  // marginRight: 10,
  backgroundColor: "#FFFFFF",
  border: "none",
  borderRadius: 15,
  outline: "none",
  fontWeight: 600,
  textAlign: "center",
  redirect_url: "",
  font: "Roboto",
  minutes: 0,
  seconds: 0,
};

class ForgetMpin extends React.Component {
  constructor(props) {
    // console.log("mobile mobile mobile", props.history.location);
    super(props);
    this.state = {
      otp: "",
      mobile: localStorage.getItem("phone_number"),
    };
  }

  handleChange = (otp) => {
    this.setState({ otp });
  };

  componentDidMount = () => {
    this.resendOtp();
    this.timer();
  };

  resendOtp = () => {
    this.setState({ otp: "" });
    this.timer();
    this.props
      .resendOtp({ phone_number: localStorage.getItem("phone_number") })
      .then((res) => {
        ToastMsg("Otp sent successfully.", "success");
      })
      .catch((err) => {
        this.setState({ loader: false });
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  submitOtp = () => {
    let data = {
      forget_password: localStorage.getItem("isForgot"),
      otp: this.state.otp,
      phone_number: localStorage.getItem("phone_number"),
    };
    this.props
      .verifyOtp(data)
      .then((res) => {
        // ToastMsg("Otp sent successfully.", "success");
        this.props.history.push("/reset-mpin");
      })
      .catch((err) => {
        this.setState({ loader: false });
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };
  // createOnBoardUser = () => {
  //   let otp = parseInt(this.state.otp);
  //   let phone_number = parseInt(this.props.user.phone_number);
  //   this.props
  //     .createOnBoardUser({
  //       otp,
  //       phone_number,
  //     })
  //     .then((result) => {
  //       if (result.message === "Verified Successfully") {
  //         // this.props.history.push("/onboarduser");
  //         this.props.history.push("/emailverify");
  //       }
  //     })
  //     .catch((err) => {
  //       let error = err.response.data.error
  //       console.log("error",error);
  //       // this.notify(error)
  //     });
  // };

  timer = () => {
    this.setState({ minutes: 1, seconds: 0 });
    this.myInterval = setInterval(() => {
      this.setState({ resendOtp: false }, () => {});
      const { seconds, minutes } = this.state;
      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
          this.setState({ resendOtp: true });
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
        }
      }
    }, 1000);
  };

  render() {
    return (
      <div className="container">
        <div className="pb-4">
          <Heading
            headingText={HEADING_FORG0TMPIN}
            onClick={() => this.props.history.goBack("/")}
            history={this.props.history}
          />

          <div className="wrapper-content">
            <div className="card-height px-4 pb-3 pt-1 w-100 text-center mx-auto bg-gray rounded-40 shadow-lg">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div className="pt-4 pb-5">
                  <img
                    src={mobile}
                    style={{ width: 77, height: 118 }}
                    className="mobile"
                    alt="PaymeIndia"
                  />
                </div>
                <Form>
                  <Form.Field className="pt-5 mb-3">
                    <label className="main__page font-size-18" name="otp">
                      Enter OTP
                    </label>
                    <div className="otpFlex px-1">
                      <OtpInput
                        containerStyle="otpFlex"
                        value={this.state.otp}
                        onChange={this.handleChange}
                        numInputs={4}
                        inputType="number"
                        renderSeparator={<span></span>}
                        renderInput={(props) => <input {...props} style={optInput} />}
                      />
                    </div>
                  </Form.Field>
                  <Form.Field
                    style={{
                      paddingTop: 40,
                      paddingBottom: 20,
                      textAlign: "center",
                      margin: "auto",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        width: 181,
                        height: 56,
                        margin: "auto",
                      }}
                    >
                      <p className="receiveOTP">
                        Didn’t receive OTP?
                        <br />
                        {this.state.resendOtp ? (
                          <a className="resendOtp" onClick={this.resendOtp}>
                            Resend
                          </a>
                        ) : (
                          <a className="resendOtp" style={{ color: "#979797" }}>
                            {" "}
                            Re-send in {this.state.minutes}:
                            {this.state.seconds < 10
                              ? `0${this.state.seconds}`
                              : this.state.seconds}
                          </a>
                        )}
                      </p>
                    </div>
                  </Form.Field>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center pt-4">
          {this.state.otp !== "" && this.state.otp.length === 4 ? (
            <button
              onClick={this.submitOtp}
              className="btn bg-orange text-white rounded-pill px-5 py-3 mb-3"
            >
              Confirm
            </button>
          ) : (
            <button className="btn bg-orange text-white rounded-pill px-5 py-3 mb-3 opacity-50">
              Confirm
            </button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  // console.log("state", state);
  return {
    user: state.user,
  };
};
export default withRouter(connect(mapStateToProps, { resendOtp, verifyOtp })(ForgetMpin));
